import { memo, useCallback, useMemo, useState } from "react";
import { useErrorSuccess } from "../../../hooks/useErrorSuccess";
import api from "../../../utils/api";

type dashBatismoItem = {
  batizado: string,
  camisatamanho: string
  dataevento: string
  descricao: string
  email: string
  estadocivil: string
  genero: 'Masculino' | 'Feminino'
  inscricao: string
  media: string
  nome: string
  nomeevento: string
  nomesede: string
  uf: string
  sede: number
  telefone: string
  usuario: number
}

interface ServicesDashboard {
  params?: {
    idsede?: number,
    inscricao?: string
  }
}

interface ResServicesDashboardProps {
  pessoasPorSede: any[];
  pessoasPorIdade: any[];
  pessoasPorGenero: any[];
  pessoasPorCamisaTamanho: any[];
  pessoasPorEstadoCivil: any[];
  todosRegistros: any[];
  totalDeEventos: any[];
  pessoasBatizadas: any[];
  getPessoasPorEventoSede:  (idsede: number) => any[];
  alterParams: (params: { idsede?: number, inscricao?: string }) => void
}

export const ServicesDashboard = (): ResServicesDashboardProps => {

  const { setErrorSuccess } = useErrorSuccess()

  const [dados, setDados] = useState<dashBatismoItem[]>([]);

  const [params, setParams] = useState<{
    idsede?: number,
    inscricao?: string
  }>();

  const getHistoryEventInSede = (idsede: number): Promise<dashBatismoItem[] | []> => {

      const req = api.get(`view/batismo`, {
        params: {
          idsede
        }
      }).then(res => res?.data).catch(error => []);

      return req;

  }

  const getDados = useCallback(async () => {
    if(params) {
      try {
        const req = await api.get('view/dash/batismo', {
          params: {
            ...params,
            ativo: true
          }
        });
        const res = await req.data;
        setDados(res);
      } catch (error) {
        setErrorSuccess({
          mensagem: JSON.stringify(error?.response?.data, null, 2),
          status: 'error'
        });
      }
    } else {
      try {
        const req = await api.get('view/dash/batismo', {
          params: {
            ativo: true
          }
        });
        const res = await req.data;
        setDados(res);
      } catch (error) {
        setErrorSuccess({
          mensagem: JSON.stringify(error?.response?.data, null, 2),
          status: 'error'
        });
      }
    }
  }, [params])

  const pessoasPorGenero = dados?.reduce(
    (prev, current) => {
    const temNoIndex = prev?.findIndex((pessoa) => pessoa?.genero == current?.genero);
    if(temNoIndex > -1) {

      prev[temNoIndex].quantidade += 1;
      return prev
    }
    /*@ts-ignore*/

    return prev?.concat({ genero: current?.genero, quantidade: 1 })
  } , [])

  const pessoasPorIdade = dados?.reduce((prev, current) => {
    const temNoIndex = prev?.findIndex((pessoa) => pessoa?.media == current?.media);
    if(temNoIndex > -1) {

      prev[temNoIndex].quantidade += 1
      return prev
    }

    return prev?.concat({ media: current?.media, quantidade: 1 })
  } , [])

  const pessoasPorSede = dados?.reduce((prev, current) => {
    const temNoIndex = prev?.findIndex((pessoa) => pessoa?.sede == current?.sede);
    if(temNoIndex > -1) {
      prev[temNoIndex].quantidade += 1
      return prev
    }
    /*@ts-ignore*/
    return prev?.concat({ sede: current?.sede, nomesede: current?.nomesede, quantidade: 1 })
  } , [])


  const pessoasPorEstadoCivil = dados?.reduce((prev, current) => {
    const temNoIndex = prev?.findIndex((pessoa) => pessoa?.estadocivil == current?.estadocivil);
    if(temNoIndex > -1) {

      prev[temNoIndex].quantidade += 1;
      return prev
    }
    /*@ts-ignore*/
    return prev?.concat({ estadocivil: current?.estadocivil, quantidade: 1 });
  } , [])

  const pessoasPorCamisaTamanho = dados?.reduce((prev, current) => {
    const temNoIndex = prev?.findIndex((pessoa) => pessoa?.camisatamanho == current?.camisatamanho);
    if(temNoIndex > -1) {

      prev[temNoIndex].quantidade += 1;
      return prev
    }
    /*@ts-ignore*/
    return prev?.concat({ camisatamanho: current?.camisatamanho, quantidade: 1 });
  } , []);


  const totalDeEventos = dados?.reduce((prev, current) => {
    const temNoIndex = prev?.findIndex((pessoa) => (pessoa?.dataevento == current?.dataevento) && (current?.nomeevento == pessoa?.nomeevento));
    if(temNoIndex > -1) {

      prev[temNoIndex].quantidade += 1;
      return prev
    }
    /*@ts-ignore*/

    return prev?.concat({ dataevento: current?.dataevento, nomeevento: current?.nomeevento, quantidade: 1 })
  } , [])

  const pessoasBatizadas = dados?.reduce((prev, current) => {
    const temNoIndex = prev?.findIndex((pessoa) => pessoa?.batizado == current?.batizado);
    if(temNoIndex > -1) {

      prev[temNoIndex].quantidade += 1;
      return prev
    }
    /*@ts-ignore*/
    return prev?.concat({ batizado: current?.batizado, inscricao: current?.inscricao, quantidade: 1 })
  } , [])

  const getPessoasPorEventoSede = async (idsede: number) => {

      const data = await getHistoryEventInSede(idsede) as dashBatismoItem[];

      return data?.reduce(
        (prev, current) => {

          const temNoIndex = prev?.findIndex((pessoa) => pessoa?.dataevento == current?.dataevento);
          if(temNoIndex > -1) {

            prev[temNoIndex].quantidade += 1;
            return prev
          }
          /*@ts-ignore*/
          return prev?.concat({ dataevento: current?.dataevento, quantidade: 1 })
        } , [])
  }

  const alterParams = (params: { idsede?: number, inscricao?: string }) => {
    setParams(params)
  }


  useMemo(() => {
    getDados()
  }, [params])

  return {
    getPessoasPorEventoSede,
    pessoasPorEstadoCivil,
    pessoasPorCamisaTamanho,
    pessoasPorGenero,
    pessoasBatizadas,
    pessoasPorIdade,
    pessoasPorSede,
    totalDeEventos,
    todosRegistros: dados,
    alterParams
  };
};

